import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID, REQUEST } from "@angular/core";
import type { Translation } from "@jsverse/transloco";
import { TranslocoService } from "@jsverse/transloco";
import type { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class LanguagePreloadService {
    private readonly translocoService = inject(TranslocoService);
    private readonly platformId = inject(PLATFORM_ID);
    private readonly request = inject(REQUEST, { optional: true });

    public preload(): Observable<Translation> {
        const activeLanguage = this.getLanguageFromUrl();
        this.translocoService.setActiveLang(activeLanguage);
        return this.translocoService.load(activeLanguage);
    }

    private getLanguageFromUrl(): string {
        let path: string;

        if (isPlatformBrowser(this.platformId)) {
            path = window.location.pathname;
        } else {
            path = this.request?.url || "";
        }

        if (path.includes("/fr")) {
            return "fr";
        } else if (path.includes("/en")) {
            return "en";
        }

        return "fr";
    }
}
